/**
 * Las direcciones de la instalación se reparten en tres zonas:
 *
 * - `/`: el directorio de aplicaciones (o el panel, si el directorio está desactivado).
 * - `/admin/*`: el panel de quien construye.
 * - `/<slug>` y `/<slug>/<página>`: cada aplicación publicada.
 *
 * Como las aplicaciones ocupan el primer tramo de la dirección, ninguna puede
 * llamarse como algo que la instalación ya sirve ahí. `uniqueSlug()` salta los
 * nombres de `RESERVED_APP_SLUGS` y el arranque renombra la que ya tuviera uno.
 */

/**
 * Primeros tramos que no pueden ser el enlace de una aplicación: el panel, la
 * API, PocketBase, los recursos de las páginas y del panel compilado, lo que
 * Vite sirve en desarrollo y las direcciones de antes, que redirigen. Los
 * archivos sueltos (`/favicon.ico`) no chocan: un enlace nunca lleva punto.
 */
export const RESERVED_APP_SLUGS: ReadonlySet<string> = new Set([
  "admin",
  "api",
  "pb",
  "plane",
  "mcp",
  "iconos",
  "fuentes",
  "assets",
  "src",
  // Direcciones de antes del prefijo `/admin`.
  "p",
  "a",
  "ajustes",
  "entrar",
  "demo",
  "directorio",
]);

/** Si un enlace de aplicación choca con una dirección de la instalación. */
export function isReservedAppSlug(slug: string): boolean {
  return RESERVED_APP_SLUGS.has(slug);
}

/** La dirección pública de una aplicación, o de una de sus páginas. */
export function appPath(slug: string, pageSlug?: string): string {
  return pageSlug ? `/${slug}/${pageSlug}` : `/${slug}`;
}

/** Si una dirección es del panel de quien construye. */
export function isPanelPath(pathname: string): boolean {
  return /^\/admin(\/|$)/.test(pathname);
}
